import { Action, createReducer, on } from '@ngrx/store';
import * as LastHeroActions from './last-hero.actions';

export const lastHeroFeatureKey = 'lastHero';

export interface State {

}

export const initialState: State = {

};


export const reducer = createReducer(
  initialState,

  on(LastHeroActions.loadVirtualEventLastHero, state => state),
  on(LastHeroActions.loadVirtualEventLastHeroSuccess, (state, action) => {
    return {
      ...state,
      ...action.data
    };
  }),
  on(LastHeroActions.loadVirtualEventLastHeroFailure, (state, action) => state),

  on(LastHeroActions.declareVirtualEventLastHero, state => state),
  on(LastHeroActions.declareVirtualEventLastHeroSuccess, (state) => state),
  on(LastHeroActions.declareVirtualEventLastHeroFailure, (state) => state),

  on(LastHeroActions.clearVirtualEventLastHero, (state) => []),

);

